/*
 * Today's hours for the café pages (eb-cafe-* sections).
 *
 * The page is cached, so Liquid cannot know what day it is for the visitor.
 * Liquid renders a fallback summary ("Open daily 6:30am-5:00pm") and the full
 * week as data; this swaps in today's line, using the cafés' own time zone
 * (both are in North Idaho, on Pacific time) rather than the visitor's.
 *
 *   [data-eb-week]  JSON array of seven hours strings, Monday first. Its text
 *                   becomes "Open today 6:30am-5:00pm", or "Closed today".
 *                   data-eb-prefix swaps "Open today" for something else.
 *   [data-eb-day]   an hours-table row; the one for today gets .is-today.
 */
(() => {
  const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  let today;
  try {
    today = new Intl.DateTimeFormat('en-US', { weekday: 'long', timeZone: 'America/Los_Angeles' }).format(new Date());
  } catch (error) {
    today = DAYS[(new Date().getDay() + 6) % 7];
  }
  const index = DAYS.indexOf(today);
  if (index < 0) return;

  document.querySelectorAll('[data-eb-week]').forEach((element) => {
    let week;
    try {
      week = JSON.parse(element.dataset.ebWeek);
    } catch (error) {
      return;
    }
    const hours = (week[index] || '').trim();
    if (!hours) return;
    const closed = /closed/i.test(hours);
    const prefix = element.dataset.ebPrefix || 'Open today';
    element.textContent = closed ? 'Closed today' : `${prefix} ${hours}`;
    element.classList.toggle('is-closed', closed);
  });

  document.querySelectorAll(`[data-eb-day="${today}"]`).forEach((row) => row.classList.add('is-today'));
})();
